import React, { useState } from 'react';
import { X, Copy, CheckCircle, Brain, Download } from 'lucide-react';

const RewardModal = ({ reward, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!reward) return null;

  const handleCopy = () => {
    if (reward.type === 'copy_paste') {
      navigator.clipboard.writeText(reward.content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden relative">
        
        {/* Header */}
        <div className="bg-indigo-600 p-6 text-white text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[radial-gradient(circle,_var(--tw-gradient-stops))] from-white to-transparent"></div>
          <Brain className="w-12 h-12 mx-auto mb-2 text-indigo-200" />
          <h2 className="text-2xl font-black uppercase tracking-wide">Level Complete!</h2>
          <p className="text-indigo-100 text-sm mt-1">You unlocked a Compliance Framework</p>
          
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 p-1 hover:bg-white/20 rounded-full transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content Body */}
        <div className="p-6 space-y-4">
          <div className="text-center">
            <h3 className="text-xl font-bold text-gray-800">{reward.title}</h3>
            <p className="text-sm text-gray-500 mt-1">{reward.description}</p>
          </div>

          <div className="bg-gray-50 border-2 border-dashed border-gray-200 rounded-xl p-4 mt-4 relative">
            {reward.type === 'copy_paste' && (
              <pre className="text-sm text-gray-700 whitespace-pre-wrap font-mono leading-relaxed">
                {reward.content}
              </pre>
            )}

            {reward.type === 'checklist' && (
              <ul className="space-y-2">
                {reward.content.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Action Button */}
          {reward.type === 'copy_paste' && (
            <button
              onClick={handleCopy}
              className={`w-full py-3 px-4 rounded-xl font-bold flex items-center justify-center gap-2 transition-all transform active:scale-95 ${
                copied 
                  ? 'bg-green-100 text-green-700 border border-green-200' 
                  : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg hover:shadow-xl'
              }`}
            >
              {copied ? (
                <>
                  <CheckCircle className="w-5 h-5" /> Copied to Clipboard!
                </>
              ) : (
                <>
                  <Copy className="w-5 h-5" /> Copy Template
                </>
              )}
            </button>
          )}
          
          {reward.type === 'checklist' && (
             <button
                onClick={onClose}
                className="w-full py-3 px-4 bg-gray-900 text-white rounded-xl font-bold hover:bg-gray-800 transition"
             >
                Got it, thanks!
             </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardModal;